<div class="veify-email-expired-container">
  <img src="assets/generalImage/email_verify_expired.svg" alt="mascot" />

  <p class="desc">{{'desc.email.verification.expired' | translate}}</p>

  <span class="redirect">{{'redirecting.to.home' | translate}}</span>
</div>
